import { useState, useRef } from "react";
import { createPortal } from "react-dom";
import { normalizar } from "./SelectBuscable";

/* Fix EE (2026-09-24): "poder tener filtros tipo google sheets en cada encabezado".
   Un botón ▾ en el encabezado de la columna abre: Ordenar A → Z / Z → A, y "Filtrar por
   valores" con buscador, "Seleccionar todo" / "Borrar", la lista de valores tildables,
   y Cancelar / Aceptar. Todo tildado es lo mismo que no filtrar.
     valores: [texto]          seleccion: Set (vacío = sin filtro)
     orden: "asc" | "desc" | null (el de esta columna)
     onOrden(dir | null)       onAplicar(Set)                                            */
export default function FiltroColumna({ titulo, valores = [], seleccion, orden, onOrden, onAplicar, testId, alinear = "left" }) {
  const [abierto, setAbierto] = useState(false);
  const [pos, setPos] = useState(null);
  const [q, setQ] = useState("");
  const [borrador, setBorrador] = useState(new Set());
  const btnRef = useRef(null);
  const activo = (seleccion && seleccion.size > 0) || !!orden;

  const abrir = () => {
    const r = btnRef.current.getBoundingClientRect();
    const ancho = 260;
    const alto = Math.min(420, window.innerHeight - 16);
    setPos({
      left: Math.max(8, Math.min(r.left, window.innerWidth - ancho - 8)),
      top: window.innerHeight - r.bottom > alto + 8 ? r.bottom + 4 : Math.max(8, r.top - alto - 4),
      ancho, alto,
    });
    setBorrador(new Set(seleccion && seleccion.size ? seleccion : valores));
    setQ("");
    setAbierto(true);
  };
  const visibles = valores.filter(v => !q.trim() || normalizar(v).includes(normalizar(q.trim())));
  const toggle = (v) => setBorrador(prev => { const n = new Set(prev); if (n.has(v)) n.delete(v); else n.add(v); return n; });
  const aceptar = () => { onAplicar(borrador.size === valores.length ? new Set() : new Set(borrador)); setAbierto(false); };
  const ordenar = (dir) => { onOrden(orden === dir ? null : dir); setAbierto(false); };

  return (
    <>
      <button type="button" ref={btnRef} onClick={abrir}
        className={`inline-flex items-center gap-1 uppercase ${alinear === "right" ? "justify-end w-full" : ""} ${activo ? "text-[#C2410C] font-bold" : ""}`}
        data-testid={testId}>
        <span>{titulo}</span>
        <span className="text-[9px]">{orden === "asc" ? "▲" : orden === "desc" ? "▼" : "▾"}</span>
        {seleccion && seleccion.size > 0 && <span className="text-[9px] normal-case">({seleccion.size})</span>}
      </button>
      {abierto && pos && createPortal(
        <>
          <div className="fixed inset-0 z-[9998]" onClick={() => setAbierto(false)} />
          <div className="fixed z-[9999] bg-white border border-gray-200 rounded-xl shadow-2xl flex flex-col text-xs normal-case font-normal text-gray-700"
            style={{ left: pos.left, top: pos.top, width: pos.ancho, maxHeight: pos.alto }} data-testid={`${testId}-panel`}>
            <button type="button" onClick={() => ordenar("asc")} className={`text-left px-3 py-2 hover:bg-gray-50 ${orden === "asc" ? "font-bold text-[#C2410C]" : ""}`} data-testid={`${testId}-az`}>
              Ordenar A → Z
            </button>
            <button type="button" onClick={() => ordenar("desc")} className={`text-left px-3 py-2 hover:bg-gray-50 border-b border-gray-100 ${orden === "desc" ? "font-bold text-[#C2410C]" : ""}`} data-testid={`${testId}-za`}>
              Ordenar Z → A
            </button>
            <p className="px-3 pt-2 font-semibold text-gray-500">Filtrar por valores</p>
            <div className="flex items-center justify-between px-3 py-1">
              <span className="flex gap-2">
                <button type="button" onClick={() => setBorrador(new Set([...borrador, ...visibles]))} className="text-[#2E6DA4] font-semibold hover:underline" data-testid={`${testId}-todo`}>
                  Seleccionar todo
                </button>
                <button type="button" onClick={() => setBorrador(new Set())} className="text-[#2E6DA4] font-semibold hover:underline" data-testid={`${testId}-borrar`}>
                  Borrar
                </button>
              </span>
              <span className="text-gray-400">{borrador.size}</span>
            </div>
            <div className="px-3 pb-1.5">
              <input value={q} onChange={e => setQ(e.target.value)} placeholder="Buscar…" autoFocus
                className="w-full border border-gray-200 rounded-lg px-2 py-1.5" data-testid={`${testId}-buscar`} />
            </div>
            <div className="overflow-y-auto flex-1 min-h-[60px] px-1">
              {visibles.length === 0 && <p className="text-gray-400 text-center py-3">Sin resultados</p>}
              {visibles.map(v => (
                <label key={v} className="flex items-center gap-2 px-2 py-1 rounded hover:bg-gray-50 cursor-pointer">
                  <input type="checkbox" checked={borrador.has(v)} onChange={() => toggle(v)} />
                  <span className="truncate">{v === "" ? "(vacías)" : v}</span>
                </label>
              ))}
            </div>
            <div className="flex justify-end gap-2 px-3 py-2 border-t border-gray-100">
              <button type="button" onClick={() => setAbierto(false)} className="px-3 py-1.5 rounded-lg border border-gray-200 hover:bg-gray-50" data-testid={`${testId}-cancelar`}>Cancelar</button>
              <button type="button" onClick={aceptar} className="px-3 py-1.5 rounded-lg bg-[#16A34A] text-white font-semibold hover:bg-[#15803D]" data-testid={`${testId}-aceptar`}>Aceptar</button>
            </div>
          </div>
        </>,
        document.body
      )}
    </>
  );
}
